import { OnInit, Type, ɵComponentDef } from '@angular/core';
import { SiteService } from 'src/app/services/site.service'
import { Message } from 'src/app/models/message';

import { Subject } from 'rxjs';

export class BaseComponent implements OnInit {

    constructor(public siteService: SiteService = null) {
    }

    ngOnInit() {

        $(".btn_back").show();
        this.siteService.sendMessage(new Message("goback", null));

    }

    ngAfterViewInit() {
        console.log("BaseComponent.ngAfterViewInit");
        common();       // common.js
    }

    public getImage(path: string, filename: string): string {
        return `${imageRoot}/img/${path}/${filename}`;
    }



    public setBackPath(path: String): void {
        this.siteService.sendMessage(new Message("goback", path));
    }


    public showLoading(msg: string = ""): void {
        this.siteService.sendMessage(new Message("show.loading", msg));
    }

    public updateLoadingMsg(msg: string = ""): void {
        this.siteService.sendMessage(new Message("update.loading.msg", msg));
    }

    public hideLoading(): void {
        this.siteService.sendMessage(new Message("hide.loading"));
    }


}

declare var $: any;
declare var imageRoot: any;
declare var common: any;